/**
 * Production Budget Monitoring API Configuration
 * 
 * Centralized endpoint constants for Production Budget Monitoring API
 */

export const PRODUCTION_MONITORING_API_CONFIG = {
    BASE_PATH: '/odoo/budget-monitoring',

    endpoints: {
        PRODUCTION_BUDGET_REPORT: '/odoo/budget-monitoring/production-budget-report',
    },
} as const;

/**
 * Default filter settings
 */
export const PRODUCTION_MONITORING_DEFAULTS = {
    REVISION: 0,
    COMPANY_ID: 1,
} as const;

/**
 * Date format constants
 */
export const DATE_FORMATS = {
    API_YEAR: 'YYYY',
    API_MONTH: 'MM',
    DISPLAY: 'MMMM YYYY',
} as const;
